export enum Model {
  ARTICLE = 'article',
  RECIPE = 'recipe',
}

export enum ModelId {
  ARTICLE = 1,
  RECIPE = 7,
  USER = 6,
  NATIVE_POST = 20,
  POLL = 12,
  VIDEO = 14,
  EXPERT = 26,
  FEATURE = 33,
  SECTION = 25,
  TAG = 34,
  AWARD = 35,
  TEASER = 38,
}

export enum SubModel {
  BLOCK_ARTICLES = 'blockArticles',
}
